<div class="nw_d__container is-fullwidth">
  <div class="nw_d__container__col">
    <div class="nw_d__component nw_d__page-header">
      <h1 class="nw_d__page-header__title">
        <span class="nw_d__page-header__content-type"></span>{{ newsItem?.shortTitle }}
      </h1>
      <div class="nw_d__page-header__subtitle"></div>
      <div class="nw_d__page-header__posteddate">{{ newsItem?.publishedDate }}</div>
    </div>
    <div class="nw_d__rte" [innerHTML]="contentSanitizedHtml(newsItem?.description)"></div>
  </div>
</div>
